import React from 'react'

const FaqHome = () => (
  <div className="hiring" style={{ marginTop: 30, paddingBottom: 40 }}>
    <style>{`
      .hiring-tabs #tab1:checked ~ #tab1sec p,
      .hiring-tabs #tab2:checked ~ #tab2sec p,
      .hiring-tabs #tab3:checked ~ #tab3sec p,
      .hiring-tabs #tab4:checked ~ #tab4sec p,
      .hiring-tabs #tab5:checked ~ #tab5sec p {
        display: block !important;
      }
      .hiring-tabs a {
        color: #ea4f6a !important;
        font-weight: 700;
      }
    `}</style>
    <h2>Frequently Asked Questions</h2>
    <div className="hiring-tabs">
      <input type="checkbox" name="dropdown" id="tab1" />
      <input type="checkbox" name="dropdown" id="tab2" />
      <input type="checkbox" name="dropdown" id="tab3" />
      <input type="checkbox" name="dropdown" id="tab4" />
      <input type="checkbox" name="dropdown" id="tab5" />

      <div className="tab" id="tab1sec">
        <label htmlFor="tab1"> </label>
        <h3>What does a professional digital marketing agency bring to your brand?</h3>
        <p>
          A competent <strong>digital marketing agency</strong> aims to increase not only your brand's visibility but also its commercial profitability. At Flatart, we use <strong>target audience analysis</strong>, the right channel selection, and data-driven strategies to connect your brand with potential customers. Unlike traditional advertising, we build <strong>brand awareness</strong> in the digital world while simultaneously focusing on <strong>conversions (sales/leads)</strong> to maximize your return on ad spend (<strong>ROAS</strong>).
        </p>
        <svg xmlns="http://www.w3.org/2000/svg" width="6.099" height="9.196" viewBox="0 0 8.099 14.196">
          <path id="Union_21" data-name="Union 21" d="M6.1,6.1,0,12.2ZM0,0,6.1,6.1Z" transform="translate(1 1)" fill="none" stroke="#a7a9bc" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        </svg>
      </div>

      <div className="tab" id="tab2sec">
        <label htmlFor="tab2"> </label>
        <h3>What should you look for when choosing the best digital marketing agency?</h3>
        <p>
          Choosing the right partner is critical for the future of your business. When selecting an agency, look at its <strong>industry experience</strong>, transparent reporting systems, and <strong>performance marketing</strong> capabilities. Working with a <strong>digital agency</strong> that doesn't just say "we're great" but can deliver integrated <strong>SEO</strong>, <strong>Google Ads</strong>, and <strong>Social Media Management</strong>—turning data into strategy—will give you a competitive edge. Flatart offers a transparent partnership with its AI-powered infrastructure and expert team.
        </p>
        <svg xmlns="http://www.w3.org/2000/svg" width="6.099" height="9.196" viewBox="0 0 8.099 14.196">
          <path id="Union_21" data-name="Union 21" d="M6.1,6.1,0,12.2ZM0,0,6.1,6.1Z" transform="translate(1 1)" fill="none" stroke="#a7a9bc" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        </svg>
      </div>

      <div className="tab" id="tab3sec">
        <label htmlFor="tab3"> </label>
        <h3>What does 360-degree digital marketing service cover?</h3>
        <p>
          <strong>360-degree digital marketing</strong> is the management of every aspect of a brand's online presence. This includes <a href="/search-engine-optimization/">SEO Consulting (Search Engine Optimization)</a> for organic traffic growth, <a href="/digital-ads/">Google &amp; Meta Ad Management</a> for rapid conversions, <a href="/social-media/">Social Media Management</a> for community building, <a href="/web-development/">Web &amp; Mobile Development</a> for improved user experience, and <a href="/ai-consulting/">AI Consulting</a> for intelligent solutions. At Flatart, we manage all these disciplines under one roof with an integrated, self-reinforcing strategy.
        </p>
        <svg xmlns="http://www.w3.org/2000/svg" width="6.099" height="9.196" viewBox="0 0 8.099 14.196">
          <path id="Union_21" data-name="Union 21" d="M6.1,6.1,0,12.2ZM0,0,6.1,6.1Z" transform="translate(1 1)" fill="none" stroke="#a7a9bc" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        </svg>
      </div>

      <div className="tab" id="tab4sec">
        <label htmlFor="tab4"> </label>
        <h3>How are digital marketing agency fees and budget management determined?</h3>
        <p>
          <strong>Digital marketing agency fees</strong> vary depending on the business's goals, competitive landscape, and the scope of services required. Rather than fixed packages, a custom budget tailored to the project's specific needs is the healthiest approach. We manage our clients' budgets as if they were our own—conducting <strong>media planning</strong> and budget optimization to achieve maximum ROI at minimum cost.
        </p>
        <svg xmlns="http://www.w3.org/2000/svg" width="6.099" height="9.196" viewBox="0 0 8.099 14.196">
          <path id="Union_21" data-name="Union 21" d="M6.1,6.1,0,12.2ZM0,0,6.1,6.1Z" transform="translate(1 1)" fill="none" stroke="#a7a9bc" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        </svg>
      </div>

      <div className="tab" id="tab5sec">
        <label htmlFor="tab5"> </label>
        <h3>How long does it take to see results from digital marketing efforts?</h3>
        <p>
          The time to see results varies by strategy. Performance-driven efforts like <strong>Google Ads and Social Media Advertising</strong> generate engagement and traffic almost immediately, though converting that to sales depends on the optimization process. Organic efforts such as <strong>SEO (Search Engine Optimization)</strong> and content marketing deliver lasting results over the medium-to-long term (typically 3–6 months). As a <strong>digital marketing agency</strong>, our priority is to both manage your short-term wins and build your long-term brand authority.
        </p>
        <svg xmlns="http://www.w3.org/2000/svg" width="6.099" height="9.196" viewBox="0 0 8.099 14.196">
          <path id="Union_21" data-name="Union 21" d="M6.1,6.1,0,12.2ZM0,0,6.1,6.1Z" transform="translate(1 1)" fill="none" stroke="#a7a9bc" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        </svg>
      </div>
    </div>
  </div>
)

export default FaqHome
